<template>
  <div class="menu">
    <div class="userList">
      <div class="nav-list"
           title="患者查询"
           :class="{active: $route.path === '/patient/list'}"
           @click="toPatientManage">
        <span>&#59169;</span>
        <a v-if="isMenuOpen">患者查询</a>
      </div>
    </div>
    <div class="nav">
      <div class="nav-list"
           :title="item.name"
           :class="{active: item.path === $route.path}"
           v-for="(item, index) in navList"
           :key="index"
           @click="handleNavClick(item)">
        <span v-html="`&${item.src};`"></span>
        <a v-if="isMenuOpen">{{item.name}}</a>
      </div>
      <div class="nav-list"
           title="退出登录"
           :class="{active: $route.path === '/login'}"
           @click="logOut">
        <span>&#59579;</span>
        <a v-if="isMenuOpen">退出登录</a>
      </div>
    </div>
  </div>
</template>

<script>
import { navList } from '@config/layout.js'

export default {
  props:{
    isMenuOpen:{
      type: Boolean
    }
  },
  data() {
    return {
      navList: navList,
    }
  },
  methods: {
    toPatientManage() {
      this.$router.push({
        path: '/patient/list',
        query: { createPatient: false },
      })
    },
    handleNavClick(item) {
      if (item.name === '患者管理') {
        this.$store.getters.goToD5()
      } else if (item.name === '训练自查') {
        this.$store.getters.goToExamine()
      } else {
        this.$router.push({ path: item.path })
      }
    },
    logOut() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
  },
}
</script>


<style lang="scss">
@import '@src/styles/variables.scss';

.menu {
  .userList {
    position: absolute;
    top: 42px;
    cursor: pointer;
    left: 2px;
    padding-left: 2px;
    right: 0;
    font-size: 18px;
    .nav-list {
      &:first-child {
        span {
          transform: rotateX(0);
        }
      }
    }
  }
  .nav {
    position: absolute;
    bottom: 32px;
    cursor: pointer;
    left: 2px;
    padding-left: 2px;
    right: 0;
    font-size: 17px;
  }
  .nav-list {
    display: flex;
    align-items: center;
    height: 44px;
    line-height: 44px;
    width: 100%;
    border-left: 2px solid transparent;
    span {
      display: inline-block;
      text-align: center;
      width: 44px;
      color: inherit;
    }
    a {
      margin-top: -3px;
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &.active {
      color: $color-text-title;
      border-left-color: $color-text-title;
    }
    &:nth-child(3) {
      span {
        transform: rotateX(180deg);
      }
    }
    &:hover {
      color: #55acee;
      background: $color-bg-hover;
    }
  }
}

</style>
